import { formatDateFr } from "@/lib/format";

export const DECENNALE_SOURCES = [
  { label: "Service Public — assurance des constructeurs et sous-traitants", url: "https://entreprendre.service-public.gouv.fr/vosdroits/F2034" },
  { label: "Service Public — modèle et mentions de l’attestation décennale", url: "https://www.service-public.gouv.fr/particuliers/vosdroits/R44868" },
  { label: "Cour de cassation — équipements ajoutés ou remplacés sur un ouvrage existant (21 mars 2024)", url: "https://www.courdecassation.fr/decision/65fbeca2affbff00080c6bb5" },
  { label: "Code des assurances — ouvrages exclus de l’obligation d’assurance et exceptions (L243-1-1)", url: "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000019265462/" },
];

export default function EditorialSources({ sources = DECENNALE_SOURCES, updated }) {
  return (
    <section aria-label="Sources et limites de ce guide" className="my-10 border-t border-ink/20 pt-6 text-sm leading-relaxed text-ink/75">
      <h2 className="font-display text-xl font-bold mb-3">Sources et repères pour vérifier</h2>
      {updated && <p className="mb-3">Contenu revu le <time dateTime={updated}>{formatDateFr(updated)}</time>.</p>}
      <ul className="space-y-2">
        {sources.map((source) => <li key={source.url}><a href={source.url} className="underline underline-offset-4 hover:text-accent" rel="noopener">{source.label}</a></li>)}
      </ul>
      <p className="mt-4 max-w-3xl">Ces repères expliquent les règles générales. La qualification des travaux, les activités déclarées et les conditions du contrat doivent être vérifiées pour votre chantier. Un exemple de dommage ne constitue pas une promesse d’indemnisation.</p>
    </section>
  );
}
